const svgDataUri = (width, height, label) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" fill="#e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#94a3b8" font-size="${Math.max(10, Math.round(width / 8))}" font-family="Arial,sans-serif">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const PLACEHOLDER_50 = svgDataUri(50, 50, 'No img');
export const PLACEHOLDER_300 = svgDataUri(300, 300, 'San pham');
export const PLACEHOLDER_350 = svgDataUri(350, 350, 'San pham');
